// extracted by mini-css-extract-plugin
export default {"content":"error_content__guiLT"};